import { apiBaseUrl } from '@config/environment'
import { tokenService } from '@features/auth'
import { ApiClient } from 'utils'

export const apiClient = new ApiClient({ apiBaseUrl, tokenService })
